// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ArrowsClockwiseIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M24.709 23.296a1 1 0 0 1 0 1.412C24.573 24.84 21.352 28 16 28c-4.674 0-8.066-2.8-10-4.981V26a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H6.93c1.54 1.919 4.695 5 9.07 5 4.5 0 7.267-2.683 7.295-2.71a1 1 0 0 1 1.414.006ZM27 5a1 1 0 0 0-1 1v2.981C24.066 6.8 20.674 4 16 4c-5.352 0-8.572 3.159-8.707 3.293A1 1 0 0 0 8.704 8.71C8.732 8.682 11.5 6 16 6c4.375 0 7.53 3.081 9.07 5H21a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
